import React from "react";
import { Easing, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { useCopy } from "../copy";
import { LOOK } from "../look";
import {
  AppViewport,
  EXPLORER,
  ExplorerScreen,
  explorerCardTop,
  PT_WIDTH,
  STORY_INDEX,
} from "../ui/AppScreens";
import { Tap } from "../ui/bits";
import { StepStage, useStepGeom } from "../ui/StepStage";
import { Sfx } from "../../b2b/ui/Sfx";

/**
 * Step 1 — pick a brand you love. A coded Explorer fed by the live brand
 * snapshot: it browses past the story brand, settles back on it, tap.
 */
export const TAP_AT = 62;

/** Explorer scroll (pt) that parks the story brand's card mid-screen. */
export const PICK_SCROLL = Math.max(
  0,
  explorerCardTop(STORY_INDEX) + EXPLORER.cardHeight / 2 - 450,
);

export const Pick: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const copy = useCopy();
  const { PT, SCREEN_X, SCREEN_Y, SW } = useStepGeom();

  const enter = spring({ frame, fps, config: { damping: 18, stiffness: 150, mass: 0.9 } });
  // Browse a little past the card, then come back to it: reads as choosing.
  const scrollY = interpolate(frame, [10, 38, 54], [0, PICK_SCROLL + 320, PICK_SCROLL], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
    easing: [Easing.bezier(0.45, 0, 0.3, 1), Easing.bezier(0.3, 0, 0.2, 1)],
  });
  const selected = interpolate(frame, [TAP_AT - 2, TAP_AT + 2, TAP_AT + 10], [0, 1, 0.8], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const cardCenterY = explorerCardTop(STORY_INDEX) - PICK_SCROLL + EXPLORER.cardHeight / 2;

  return (
    <StepStage
      background={LOOK.sky}
      step={1}
      label={copy.steps.pick}
      phoneOffsetY={(1 - enter) * 900}
      screen={
        <AppViewport screenWidth={SW}>
          <ExplorerScreen scrollY={scrollY} selected={selected} />
        </AppViewport>
      }
    >
      <Tap x={SCREEN_X + (PT_WIDTH / 2) * PT} y={SCREEN_Y + cardCenterY * PT} at={TAP_AT} />
      <Sfx sound="click" at={TAP_AT} />
    </StepStage>
  );
};
